<template>
  <v-container>
    <h4 class="text-center mt-3">Colores</h4>

    <h5 class="text-center mt-5">Background</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.background_color"
      @event="change_background_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Foreground</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.foreground_color"
      @event="change_foreground_color"
    ></koiote-color-picker-vue>

    <h5 class="text-center mt-5">Borde</h5>
    <koiote-color-picker-vue
      class="mt-1"
      :pcolor="selectedItem.customized.border_color"
      @event="change_border_color"
    ></koiote-color-picker-vue>

    <h4 class="text-center mt-7">Propiedades</h4>

    <v-text-field
      prefix="Título:"
      class="ml-3 mr-3 mb-5"
      v-model="selectedItem.customized.label"
      @click="updateEditing(true)"
    >
    </v-text-field>

  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";

export default {
  name: "KoioteLabelProperties",

  components: {
    KoioteColorPickerVue,
  },

  computed: {
    ...mapState(["selectedItem"]),

    value() {
      return (
        this.actualPage()
          .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          .customized.vartable.find((v) => v.formatted_address == this.selectedItem.customized.address)?.value || 0
      );
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions(["updateEditing"]),

    change_background_color(nc) {
      this.selectedItem.customized.background_color = nc;
    },

    change_foreground_color(nc) {
      this.selectedItem.customized.foreground_color = nc;
    },

    change_border_color(nc) {
      this.selectedItem.customized.border_color = nc;
    },
  },
};
</script>
